export default __webpack_public_path__ + "static/media/Icon2.9350034e.svg";